module.exports = __webpack_public_path__ + "static/img/Permiso(19).401561b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(19).jpg
// module id = PKmh
// module chunks = 0